import { RefObject, useRef } from 'react';
import clsx from 'clsx';
import styles from './DataAvailabilityButton.module.scss';
import Button from '../../../../../common/_custom/Button/Button';
import { infoPurpleIcon } from '../../../../../assets/hostedassets';
import { DATA_AVAILABILITY_COPY } from '../constants/reconciliationsCopy';
import { useDataAvailabilityEntry } from '../hooks/useDataAvailabilityEntry';

interface DataAvailabilityInlineButtonProps {
    onClick: () => void;
    buttonRef: RefObject<HTMLButtonElement>;
    expanded: boolean;
    className?: string;
}

/** The "ⓘ Data Availability" button itself — stateless, the host owns the modal. */
export function DataAvailabilityInlineButton({ onClick, buttonRef, expanded, className }: Readonly<DataAvailabilityInlineButtonProps>) {
    return (
        <Button
            type="button"
            buttonRef={buttonRef}
            className={clsx(styles.DataAvailabilityButton, className)}
            icon={<img src={infoPurpleIcon} alt="" aria-hidden="true" className={styles.InfoIcon} />}
            text={DATA_AVAILABILITY_COPY.BUTTON}
            aria-haspopup="dialog"
            aria-expanded={expanded}
            onClick={onClick}
        />
    );
}

interface DataAvailabilityButtonProps {
    orgId: string;
    className?: string;
}

/** The "ⓘ Data Availability" entry point plus the modal it opens. Opens on click only — never on hover. */
function DataAvailabilityButton({ orgId, className }: Readonly<DataAvailabilityButtonProps>) {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const { isOpen, open, modal } = useDataAvailabilityEntry(orgId);

    return (
        <>
            <DataAvailabilityInlineButton buttonRef={buttonRef} className={className} expanded={isOpen} onClick={() => open(buttonRef)} />
            {modal}
        </>
    );
}

export default DataAvailabilityButton;
